import type { ReactNode } from 'react';

export interface KeyValueItem {
  label: string;
  value: ReactNode;
}

export interface KeyValueProps {
  items: KeyValueItem[];
  /** 追加のレイアウト用クラス（ProblemNoticeのメタ情報など）。 */
  className?: string;
}

/** run/Taskのメタ情報を「開始 / 終了 / 所要 / 開始ユーザー / 終了イベント」の形で横並びに出す。 */
export function KeyValue({ items, className }: KeyValueProps) {
  const classes = className === undefined ? 'keyvalue' : `keyvalue ${className}`;
  return (
    <dl className={classes}>
      {items.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
